var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.5V24.5L28.5 26.5M34.5 24.5C34.5 30.0228 30.0228 34.5 24.5 34.5C18.9772 34.5 14.5 30.0228 14.5 24.5C14.5 18.9772 18.9772 14.5 24.5 14.5C30.0228 14.5 34.5 18.9772 34.5 24.5Z",
    stroke: "#3538CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock1);
export default __webpack_public_path__ + "static/media/clock-1.a1555dddc477b0c862115f0c4c934bec.svg";
export { ForwardRef as ReactComponent };